import { CollectionStatusEnum } from "@kanpla/api-contract";
import { useNavigate } from "react-router-dom";

import { type Child } from "~/api/children/types";
import { UserCard } from "~/components/collect/operator/user-card";
import {
  UserGrid,
  type UserGridProps
} from "~/components/collect/operator/user-grid";
import { usePaginationContext } from "~/components/pagination/context";
import { collectActions } from "~/providers/store/collect/actions";
import { employeeActions } from "~/providers/store/employee";

type StudentsGridProps = {
  columns: NonNullable<UserGridProps["columns"]>;
};

/** Students grid for the current page. Selecting a student opens the user view. */
export const StudentsGrid = ({ columns }: StudentsGridProps) => {
  const navigate = useNavigate();
  const { currentPageItems: students } = usePaginationContext<Child>();

  const handleOnStudentClick = (student: Child) => {
    // Hand-off that opens a user's collect view.
    employeeActions.setAuthEmployee({
      employeeChildId: student.id,
      groupName: student.groupName
    });
    collectActions.setFlow("collect");
    navigate(
      `/collect/orders?childId=${student.id}&groupName=${encodeURIComponent(
        student.groupName
      )}`
    );
  };

  return (
    <UserGrid columns={columns}>
      {students.map((student) => (
        <UserCard
          key={student.id}
          status={student.collectionStatus ?? CollectionStatusEnum.NO_ORDERS}
          onClick={() => {
            handleOnStudentClick(student);
          }}
        >
          <UserCard.Avatar name={student.name} />
          <UserCard.Content>
            <UserCard.Name>{student.name}</UserCard.Name>
            <UserCard.Group>{student.groupName}</UserCard.Group>
          </UserCard.Content>
          <UserCard.StatusIndicator />
        </UserCard>
      ))}
    </UserGrid>
  );
};
